import { Injectable, computed, signal } from '@angular/core';

/**
 * Tracks which user (if any) an ADMIN is currently viewing in the read-only
 * backoffice "view as" screens (e.g. /admin/view/:userId/calendar). Powers the
 * ActingAsInterceptor (adds `actingAs` to acting-as endpoints) and the
 * read-only flags on the calendar components. Must NOT inject
 * ManagedDoctorsService to avoid an interceptor/service injection cycle.
 */
@Injectable({ providedIn: 'root' })
export class AdminViewAsService {
  private targetUserIdSignal = signal<string | null>(null);

  private targetRoleSignal = signal<string | null>(null);

  readonly targetUserId = this.targetUserIdSignal.asReadonly();

  readonly targetRole = this.targetRoleSignal.asReadonly();

  readonly isActive = computed(() => !!this.targetUserIdSignal());

  setTarget(id: string): void {
    this.targetUserIdSignal.set(id);
    this.targetRoleSignal.set(null);
  }

  setTargetRole(role: string): void {
    this.targetRoleSignal.set(role);
  }

  clear(): void {
    this.targetUserIdSignal.set(null);
    this.targetRoleSignal.set(null);
  }
}
